import { setInfuseApiResponse } from 'logic/store/infuse/actions';
import { INFUSE } from 'constants.js';
import { isScriptNotAttached } from './utils';

export default {
  useAttachApi(config, dispatch) {
    const tenant = config.tenantId;
    const snippetId = config.snippetId;
    const handShakeServer = config.handShakeServer;

    window.getInfuseApiDetails = (api) => {
      const actualRunningValue = api?.v4?.rapport_running;
      dispatch(
        setInfuseApiResponse({
          running: !!actualRunningValue,
          isInstantiated: actualRunningValue ?? INFUSE.IS_UNDEFINED
        })
      );
    };

    if (tenant && tenant !== null && handShakeServer) {
      const script = document.createElement('script');
      const parts = [
        document.location.protocol === 'https:' ? 'https:/' : 'http:/',
        handShakeServer,
        snippetId,
        'rapi.js?f=getInfuseApiDetails'
      ];

      script.setAttribute('async', true);
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', parts.join('/'));

      // Verify, whether script is already included
      // If it's still not included, then we are going to insert it to the DOM
      if (isScriptNotAttached(handShakeServer, 'rapi')) {
        document.body.insertAdjacentElement('afterbegin', script);
      }
    }
  },
  attachSplash(config) {
    const tenant = config.tenantId;
    const snippetId = config.snippetId;
    const handShakeServer = config.handShakeServer;

    if (tenant && tenant !== null && handShakeServer) {
      const script = document.createElement('script');
      const parts = [
        document.location.protocol === 'https:' ? 'https:/' : 'http:/',
        handShakeServer,
        snippetId,
        'splash.js'
      ];

      script.setAttribute('async', true);
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', parts.join('/'));

      // Verify, whether script is already included
      // If it's still not included, then we are going to insert it to the DOM
      if (isScriptNotAttached(handShakeServer, 'splash')) {
        document.body.insertAdjacentElement('afterbegin', script);
      }
    }
  }
};
